import React from 'react';
import { motion } from 'framer-motion';
import { packItems, formatArs } from '../data/content';
const totalValue = packItems.reduce((sum, item) => sum + item.value, 0);
export function ValueStack() {
  return <section className="bg-linen py-16 sm:py-24" aria-labelledby="pack-title" data-id="element-200" data-mp="1q94pq5ohrf1p">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[0.9fr_1fr] lg:gap-16" data-id="element-201" data-mp="1u9ohsuu7jsgz">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55
      }} className="overflow-hidden rounded-3xl border-4 border-white shadow-soft sm:rounded-[2rem] sm:border-8" data-id="element-202" data-mp="2hz0sjz56o8le">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/4ec493ac-4c1d-48d4-9bff-cb8ad05cd4ff.jpg" alt="Manual Maestro Amigurumi mostrado en libro impreso, tablet y celular" className="h-full w-full object-cover" data-id="element-203" data-mp="2d6pqapmz0apo" />
        </motion.div>

        <div data-id="element-204" data-mp="1teleuq7hneod">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-205" data-mp="1tg4ssa5o9dmz">
            El pack completo
          </span>
          <h2 id="pack-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-206" data-mp="1oeffsoyw2pw9">
            Al inscribirte hoy, te llevás todo esto
          </h2>

          <ul className="mt-8 space-y-3" data-id="element-207" data-mp="1yd50sqm30qgq">
            {packItems.map((item, index) => <motion.li key={item.name} initial={{
            opacity: 0,
            x: 16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.4,
            delay: index * 0.07
          }} className="flex items-center gap-4 rounded-2xl border border-wool bg-white p-4 sm:p-5" data-id="element-208" data-mp="2c4jjewc2upn9" data-mpi={index}>
                <span className="text-2xl" aria-hidden="true" data-id="element-209" data-mp="rq9g8ggtqnou">
                  {item.label}
                </span>
                <div className="min-w-0 flex-1" data-id="element-210" data-mp="mt9c4b3jbv0d">
                  <p className="font-display text-base font-black leading-snug text-ink sm:text-lg" data-id="element-211" data-mp="2mu7gruhdmhq3">
                    {item.name}
                  </p>
                  <p className="text-sm text-muted" data-id="element-212" data-mp="2vtu8tpo7ub6h">{item.detail}</p>
                </div>
                <p className="shrink-0 text-right text-sm font-bold text-muted" data-id="element-213" data-mp="2vw70wvnou1x9">
                  Valor
                  <span className="block text-base text-ink" data-id="element-214" data-mp="30qkquijkzguj">{formatArs(item.value)}</span>
                </p>
              </motion.li>)}
          </ul>

          <div className="mt-6 flex items-center justify-between rounded-2xl bg-ink px-6 py-5 text-cream" data-id="element-215" data-mp="3aptq9qx7tnoa">
            <p className="font-display text-lg font-black uppercase tracking-wide" data-id="element-216" data-mp="3fj4qh97iv678">Valor total</p>
            <p className="font-display text-2xl font-black" data-id="element-217" data-mp="3ji566iupdsq0">{formatArs(totalValue)} ARS</p>
          </div>
        </div>
      </div>
    </section>;
}